import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SendNotificationComponent } from '@notification/send-notification/send-notification.component';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
  title: string;

  name: string;

  position: string;

  deleteTagList: any = [];

  addTagList: any = [];

  mode: string;

  deleteRole : any;

  deleteRegion: any;

  deleteDeparment: any;

  constructor(
    public dialogRef: MatDialogRef<SendNotificationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(data && data.teamValue){
      console.log(data.teamValue)
      this.position = data.teamValue.position?data.teamValue.position : data.teamValue.title
    }
    if(data && data.value){
      this.title = data.value.title;
      this.name = data.value.name;
      this.position = data.value.jobPostion;
    }
    this.mode = data.mode;
    switch(data.mode){
        case 'DELETE':
          this.deleteTagList = data.value;
          break;
        case 'ROLE-DELETE':
          this.deleteRole = data.value;
          break;
        case 'REGION-DELETE':
          this.deleteRegion = data.value;
          break;
        case 'DEPARTMENT-DELETE':
          this.deleteDeparment = data.value;
          break;
        default:
          this.addTagList = data.value;
          break;
    }
  }

  ngOnInit() {}

  public onConfirmation(status: boolean, data?: any) {
    const response = { status, data };
    this.dialogRef.close(response);
  }
}
